"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import InventoryHoldNoticeModal from "@/components/common/InventoryHoldNoticeModal";
export const HOLD_NOTICE_EVENT = "thiscar:show-hold-notice";

/** Dispatch from any client component to show the inventory hold notice. */
export function requestHoldNotice() {
  window.dispatchEvent(new CustomEvent(HOLD_NOTICE_EVENT));
}

/**
 * Client island that shows the inventory hold notice when a lead form
 * (test drive / check availability) reports success. Event-based so the
 * rest of the vehicle detail page can stay server-rendered.
 */
export default function HoldNoticeListener() {
  const $ = _c(5);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const show = () => setIsOpen(true);
      window.addEventListener(HOLD_NOTICE_EVENT, show);
      return () => window.removeEventListener(HOLD_NOTICE_EVENT, show);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(false);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isOpen) {
    t3 = <InventoryHoldNoticeModal isOpen={isOpen} onClose={t2} />;
    $[3] = isOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}